import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Add = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 8H12M8 4V12" stroke={color} />
    </svg>
  ),
)

Add.displayName = 'Add'

Add.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Add
